module.exports = __webpack_public_path__ + "media/images/prevention_form/resilienz-23d78bc9ba4adc6313d45bf0544a3fce.svg";